export const SECTIONS = {
  charts: 'charts',
  data: 'data'
}
